import styled from '@emotion/styled';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';

import { useCustomSearchParams } from '@selfserve/react-hooks';
import { responseTypes } from '@selfserve/react-utils';

import { useSortByUrl } from '../hooks/use-sort-by-url';

import { IContextData } from './admin-layout';

import { getAdminSearchValue } from '../utils/get-admin-search-value';

import { IBeFilter } from '../types';

import { usePartnersRequest } from '../data';

import { StyledPageTitle } from '../ui/admin-styled-components';
import { AdminSpinner } from '../ui/admin-spinner';
import { AdminPartnersList } from './admin-partners-list';

const StyledAdminPartnersContainer = styled('div')`
  height: 100%;
`;

export const AdminPartners = () => {
  const { t } = useTranslation();
  const [query] = useCustomSearchParams();
  const { openErrorModal } = useOutletContext<IContextData>() || {};
  const { sortValue, sortType } = useSortByUrl();
  const [beFilter, setBeFilter] = useState<null | IBeFilter>(null);
  const { data, isLoading } = usePartnersRequest({
    pageSize: +query['pageSize'],
    pageIndex: +query['pageIndex'] - 1,
    ...(beFilter && beFilter),
    ...(query['status'] && {
      status: (query['status'] as string[])?.join(','),
    }),
    ...(sortValue && {
      sortByItems: sortValue,
    }),
    ...(sortType && {
      sortByDirection: sortType,
    }),
  });
  const partners = useMemo(() => {
    if (data?.data && Array.isArray(data?.data)) return data?.data;
    return [];
  }, [data]);

  useEffect(() => {
    if (
      data?.status &&
      !String(data?.status).startsWith(responseTypes.SUCCESS)
    ) {
      openErrorModal({ text: data?.data?.message });
    }
  }, [data]);

  return (
    <StyledAdminPartnersContainer>
      <StyledPageTitle isSmall>{t('common.admin-partners')}</StyledPageTitle>
      <AdminPartnersList
        partners={partners}
        handleSetBeFilter={getAdminSearchValue(setBeFilter)}
      />
      <AdminSpinner loading={isLoading} fullScreen />
    </StyledAdminPartnersContainer>
  );
};
